import { Injectable } from '@angular/core';

import { Automation } from 'src/models/index';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';

export interface AutomationAssistantMessage {
  role: 'user' | 'assistant';
  content: string;
  automationData?: Partial<Automation>;
}

export interface AutomationAssistantRequest {
  history: AutomationAssistantMessage[];
  currentAutomation?: Partial<Automation>;
}

@Injectable({
  providedIn: 'root',
})
export class AutomationAssistantService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
  ) {}

  /**
   * Check if the automation assistant feature is enabled for the current tenant
   */
  isFeatureEnabled(): boolean {
    return this.authService.tenant?.featureFlags?.AUTOMATION_ASSISTANT === true;
  }

  /**
   * Send a message to the automation assistant
   */
  async sendMessage(request: AutomationAssistantRequest): Promise<AutomationAssistantMessage[]> {
    if (!this.isFeatureEnabled()) {
      throw new Error('Automation assistant feature is not enabled');
    }

    return await this.apiService.postPromise('/automation-assistant', request);
  }
}
